<template>
    <div class="position-relative">
        <div class="container mx-auto">
            <div class="container">
                <div class="m-0 vh-50 row justify-content-center align-items-center">
                    <SearchComponent></SearchComponent>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchComponent from '@/components/SearchComponent.vue'
export default {
    name: 'SearchView',
    data(){
        return {

        }
    },
    mounted(){

    },
    methods:{

    },
    components: {
        SearchComponent
    }
}
</script>
